<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入手机号" v-model="phone"  style="width:300px;" @change="getData" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>

        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="630" style="width: 100%">
                <el-table-column  prop="avatar_url" label="头像" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <table-img v-if="scope.row.avatar_url" :src="scope.row.avatar_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column  prop="phone" label="手机号" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="integral" label="积分" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="coupon_record_count" label="优惠券使用张数" align="center" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-pagination background @current-change="loadPage" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </div>
    </section>
</template>



<script>
import axios from 'axios'
import tableImg from '@/components/Image.vue'

export default {
    components: {tableImg},
    data() {
        return {
            phone:'',
            page:1,
            total:0,
            size: 0,
            tableData:[],
        }
    },
    methods: {
        search() {
            this.page = 1;
            this.getData()
        },
        getData(){
            let params = {
                page:this.page
            }
            if(this.phone != ""){
                params.phone = this.phone
            }
            axios({
                url:'https://activityapi.ggdnn.com/query/activity-users-list',
                params: params
            }).then(res => {
                if(res) {
                    if(res.data.code == 20000) {
                        const {data} = res.data
                        this.tableData = data.data
                        this.total = data.total
                        this.size = data.per_page
                    }
                } else {
                    this.tableData = []
                }
            })
            
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
    },
    created(){
        this.getData()
    }
}
</script>

<style lang="less" scoped>
// .section{

// }
</style>


